import { useMutation, useQuery } from '@tanstack/vue-query';
import { newsletterService } from '@/services/newsletter.service';
import { computed, type MaybeRefOrGetter, toValue } from 'vue';

const QUERY_KEY = 'newsletter-blacklist';

export const useSetNewsletterBlacklisted = () => {
  return useMutation({
    mutationFn: async ({ email, blacklisted }: { email: string; blacklisted: boolean }) => {
      return await newsletterService.setContactBlacklisted(email, blacklisted);
    },
  });
};

export const useGetNewsletterBlacklisted = (email?: MaybeRefOrGetter<string>) => {
  return useQuery({
    queryKey: [QUERY_KEY, email],
    queryFn: async () => {
      return await newsletterService.getContactBlacklisted(toValue(email)!);
    },
    enabled: computed(() => !!toValue(email)),
  });
};
